import { Stack, Link, Typography } from '@mui/material';
import { useRegisterFormController } from '../../hooks/useRegisterFormController';
import StyledForm from '../forms/shared/StyledForm';
import { DynamicFormFields } from '../shared/DynamicFormFields';
import type { RegisterFormProps } from '../../hooks/registerForm.shared';
import TurnstileChallenge from '../shared/TurnstileChallenge';

export type { RegisterFormProps } from '../../hooks/registerForm.shared';

const styles = {
  select: {
    color: 'neutral.25',
    '& .MuiSelect-icon': { color: 'neutral.300' },
  },
  menuPaper: {
    backgroundColor: 'background.paper',
    color: 'neutral.25',
    maxHeight: 300,
  },
  loginContainer: {
    mt: 4,
    mb: 2,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 1,
    px: 2,
  },
  checkboxLabel: {
    color: 'neutral.200',
  },
  checkbox: {
    pl: 0,
  },
};

const RegisterForm = ({ promoCode }: RegisterFormProps) => {
  const {
    t,
    control,
    errors,
    isSubmitting,
    getValues,
    setValue,
    fieldsToRender,
    handleClose,
    onSubmit,
    openLoginForm,
    turnstile,
  } = useRegisterFormController({ promoCode });

  return (
    <>
      <StyledForm
        title={t('register.title')}
        submitTitle={t('register.title')}
        onSubmit={onSubmit}
        onClose={handleClose}
        isSubmitting={isSubmitting}
        submitButton={{ disabled: !turnstile.isReady }}
      >
        <DynamicFormFields
          fields={fieldsToRender}
          control={control}
          errors={errors}
          isSubmitting={isSubmitting}
          getValues={getValues}
          setValue={setValue}
        />
        <TurnstileChallenge {...turnstile.widgetProps} />
      </StyledForm>
      <Stack sx={styles.loginContainer}>
        <Typography variant='body2'>{t('register.alreadyHaveAccount')}</Typography>
        <Link component='button' onClick={openLoginForm}>
          {t('register.signIn')}
        </Link>
      </Stack>
    </>
  );
};

export default RegisterForm;
